module.exports = __webpack_public_path__ + "static/media/qc-3.33ccccfd.png";